import { api } from '@packages/backend/convex/_generated/api';
import { useQuery } from 'convex-helpers/react';
import type React from 'react';
import { useEffect } from 'react';

export const VersionGuard = ({ children }: { children: React.ReactNode }) => {
  const { data } = useQuery(api.app.getClientConfig);
  const serverCommitSha = data?.commitSha;

  useEffect(() => {
    if (!serverCommitSha || serverCommitSha === __COMMIT_SHA__ || __COMMIT_SHA__ === 'dev') return;
    const key = `version-reload-${serverCommitSha}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    navigator.serviceWorker
      ?.getRegistrations()
      .then((regs) => Promise.all(regs.map((r) => r.unregister())))
      .then(() => window.location.reload());
  }, [serverCommitSha]);

  return children;
};
